import { LOCAL_STORAGE_BLOCK_SEARCH_MODE_KEY, LOCAL_STORAGE_LIST_CARD_VIEW_KEY } from 'config';
import { parseSearchModePreference, SearchModePreference } from './blocks/blockSearch';

export function prettyMediaFilenameForShow(filename: string | undefined) {
  if (filename === undefined) {
    return filename;
  }

  const reg = /.+[0-9]+_[0-9]+_(.+)/;
  const found = filename.match(reg);
  if (found !== null && found.length === 2) {
    return found[1];
  }
  return filename;
}

/*
  Blocks
*/

// List or card view - localstorage
export enum View {
  CARD = 'card',
  LIST = 'list',
}

export function getView(): View {
  const storageValue: string | null = localStorage.getItem(LOCAL_STORAGE_LIST_CARD_VIEW_KEY);

  return storageValue ? View[storageValue.toUpperCase()] : View.LIST;
}

export function setView(newView: View) {
  localStorage.setItem(LOCAL_STORAGE_LIST_CARD_VIEW_KEY, newView);
}

export function toggleView() {
  const currentView = getView();
  setView(currentView === View.LIST ? View.CARD : View.LIST);
}

// The search the user last picked with the search slider - localstorage
export function getSearchModePreference(): SearchModePreference {
  try {
    return parseSearchModePreference(localStorage.getItem(LOCAL_STORAGE_BLOCK_SEARCH_MODE_KEY));
  } catch {
    return SearchModePreference.DEFAULT;
  }
}

export function setSearchModePreference(preference: SearchModePreference) {
  try {
    localStorage.setItem(LOCAL_STORAGE_BLOCK_SEARCH_MODE_KEY, preference);
  } catch {
    // The choice then only lasts until the page is reloaded
  }
}
